import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {Dimensions, StyleSheet, View} from 'react-native';
import {Text} from 'trpc-react-native-ui';
import {formatValue} from '../../../lib/usage-formatters';
import I18n from '../../../lib/i18n';

const windowWidth = Dimensions.get('window').width;

const styles = StyleSheet.create({
  container: {
    height: 20,
    flexDirection: 'row',
  },
  legend: {
    position: 'absolute',
    backgroundColor: 'transparent',
  },
  text: {
    textAlign: 'center',
  },
});

class CharacteristicSliderAxis extends Component {
  // Giving an initial width of 150 to legends (big enough to hold text)
  state = {
    legendWidth: Array.from(new Array(this.props.values.length), () => 150),
  };

  _getOffset(index) {
    const length = this.props.values.size;
    const {outerMargin, sliderMargin, sliderFlex} = this.props;

    const totalFlex = sliderFlex + 2;
    const containerWidth = windowWidth - 2 * outerMargin;

    // (windowWidth-2*outerMargin) represents the width of the whole container
    // It is splat into sliderFlex+2 parts
    // (the usage type, three for the slider and one for the price)
    // We add sliderMargin which is the left margin in the slider container
    let initialOffset = containerWidth / (sliderFlex + 2) + sliderMargin;
    if (I18n.rtl()) {
      initialOffset = containerWidth - initialOffset;
    }

    const sliderWidth =
      (sliderFlex / totalFlex) * containerWidth - 2 * sliderMargin;
    const increment = sliderWidth / (length - 1);

    let offset = initialOffset + index * increment;
    if (I18n.rtl()) {
      offset = initialOffset - index * increment;
    }

    // We always substract half the computed width of the text to center the legend
    return offset - this.state.legendWidth[index] / 2;
  }

  _measureLegend(element, index) {
    const legendWidth = this.state.legendWidth;
    legendWidth[index] = element.nativeEvent.layout.width;
    this.setState({legendWidth});
  }

  _formatValue(value, unitType) {
    if (isNaN(value)) {
      return I18n.t(`VALUE_${value}`);
    }

    return formatValue(value, unitType);
  }

  render() {
    const {unitType = ''} = this.props;
    const values = unitType === 'EXTRA' ? [] : this.props.values;
    return (
      <View style={styles.container}>
        {values.map((element, index) => (
          <View
            key={index}
            style={[styles.legend, {left: this._getOffset(index)}]}
            onLayout={event => this._measureLegend(event, index)}>
            <Text style={styles.text}>
              {this._formatValue(
                element.value,
                element.unitType || element.unit,
              )}
            </Text>
          </View>
        ))}
      </View>
    );
  }
}

CharacteristicSliderAxis.propTypes = {
  values: PropTypes.object.isRequired,
  unitType: PropTypes.string,
  sliderMargin: PropTypes.number.isRequired,
  outerMargin: PropTypes.number.isRequired,
  sliderFlex: PropTypes.number.isRequired,
};

export default CharacteristicSliderAxis;
